// extracted by mini-css-extract-plugin
export var contentBody = "_c4-a";
export var headerImage = "_c4-2";
export var imageActions = "_c4-7";
export var imageButton = "_c4-8";
export var imageButtonIcon = "_c4-9";
export var imageHeader = "_c4-4";
export var imageHeaderText = "_c4-5";
export var imageOverlay = "_c4-3";
export var imageTitle = "_c4-6";
export var imageWrapper = "_c4-1";
export var taskList = "_c4-b";
export var widget = "_c4-0";